import React from 'react'
import { useTransition } from 'react-spring'

import SidePanel from 'components/SidePanel'
import QuestionPanel from 'components/QuestionPanel'
import NavigationBar from 'components/NavigationBar'
import WelcomeModal from 'components/WelcomeModal'

import { useQuizContext } from 'store/QuizStore'

import { Root, Body, Footer, SideColumn, QuestionColumn } from './Quiz.styled.js'

const Quiz = () => {
  const { showWelcome } = useQuizContext()

  const welcomeTransition = useTransition(showWelcome, null, {
    from: { opacity: 0 },
    enter: { opacity: 1 },
    leave: { opacity: 0 },
  })

  return (
    <Root pt={[80, 110, 80, 80]}>
      {welcomeTransition.map(
        ({ item, key, props }) => item && <WelcomeModal key={key} style={props}></WelcomeModal>
      )}
      <Body>
        {!showWelcome && (
          <div className="Inner">
            <SideColumn>
              <SidePanel></SidePanel>
            </SideColumn>
            <QuestionColumn px={[20, 20, 20, 20]}>
              <QuestionPanel></QuestionPanel>
            </QuestionColumn>
          </div>
        )}
      </Body>
      <Footer>
        <SideColumn></SideColumn>
        <QuestionColumn px={[20, 20, 20, 20]}>
          <NavigationBar></NavigationBar>
        </QuestionColumn>
        {/* <SideColumn></SideColumn> */}
      </Footer>
    </Root>
  )
}

export default Quiz
